// import Admin from "./pages/Admin";
import Auth from "./pages/Auth";
import Home from "./pages/Home";
import Catalog from "./pages/Catalog";
import ProductCard from "./pages/ProductCard";
import Basket from "./pages/Basket";
import About from "./pages/About";
import PayAndShip from "./pages/PayAndShip";
import Warranty from "./pages/Warranty";
import Refund from "./pages/Refund";
import Profile from "./pages/Profile";
import History from "./pages/History";
import PostingPage from "./pages/PostingPage";

import SuccessPage from "./pages/Pay/SuccessPage";
import FailPage from "./pages/Pay/FailPage";
import SuccessPostingPage from "./pages/Pay/SuccessPostingPage";
import PayPage from "./pages/Pay/PayPage";
import xz from "./xz";
import SearchPage from "./pages/SearchPage";
import AurusPage from "./pages/AurusPage";
import PromotionsPage from "./pages/PromotionsPage";





// import Checkout from "./pages/Checkout";
// import ProductPage from "./pages/ProductPage";
// import PostingPage from "./pages/PostingPage";
// import Profile from "./pages/Profile";
// import History from "./pages/History";
// import ToDelivering from "./pages/ToDelivering";
// import Map from "./pages/Map";

import {
    // ADMIN_ROUTE,
    BASKET_ROUTE,
    PRODUCT_ROUTE,
    LOGIN_ROUTE,
    HOME_ROUTE,
    CATALOG_ROUTE,
    //SPLIT_SYSTEMY_NASTENNYE_ROUTE,
    PROFILE_ROUTE,
    HISTORY_ROUTE,
    POSTING_ROUTE,
    // REGISTRATION_ROUTE,
    //CHECKOUT_DELIVERING_ROUTE,
    ///CHECKOUT_ROUTE,
    //MAP_ROUTE,
    ABOUT_ROUTE,
    PAY_AND_SHIP_ROUTE,
    WARRANTY_ROUTE,
    REFUND_ROUTE, CONTACTS_ROUTE, SERVICES_ROUTE, BRANDS_ROUTE, POLICY_OPD_ROUTE,
    PAY_SUCCESS,
    PAY_FAIL,
    POSTING_SUCCESS,
    PAY_PAGE,
    XZ_ROUTE,
    SEARCH_PAGE,
    AURUS_PAGE,
    PROMOTIONS_PAGE
} from "./utils/const";
import Contacts from "./pages/Contacts";
import Services from "./pages/Services";
import Brands from "./pages/Brands";
import PolicyOpd from "./pages/PolicyOpd";




export const authRoutes = [


    // {
    //     path: BASKET_ROUTE,
    //     Component: Basket
    // },
    // {
    //     path: CHECKOUT_ROUTE,
    //     Component: Checkout
    // },
    // {
    //     path: CHECKOUT_DELIVERING_ROUTE,
    //     Component: ToDelivering
    // },

    {
        path: PROFILE_ROUTE,
        Component: Profile
    },
    {
         path: HISTORY_ROUTE,
         Component: History
    },
    {
        path: POSTING_ROUTE + '/:postingNumber',
        Component: PostingPage
    },


    // {
    //     path: ADMIN_ROUTE,
    //     Component: Admin
    // },

]

export const publicRoutes = [
    {
      path: PROMOTIONS_PAGE,
      Component: PromotionsPage
    },
    {
      path: SEARCH_PAGE,
      Component: SearchPage
    },
    {
      path: AURUS_PAGE,
      Component: AurusPage
    },
    {
        path: XZ_ROUTE,
        Component: xz
    },
    {
        path: PAY_PAGE,
        Component: PayPage
    },
    {
        path: PAY_SUCCESS,
        Component: SuccessPage
    },
    {
        path: PAY_FAIL,
        Component: FailPage
    },
    {
        path: POSTING_SUCCESS,
        Component: SuccessPostingPage
    },
    {
        path: LOGIN_ROUTE,
        Component: Auth
    },
    {
        path: HOME_ROUTE,
        Component: Home
    },
    {
        path: CATALOG_ROUTE, 
        Component: Catalog
    },
    {
        path: CATALOG_ROUTE + '/:category', 
        Component: Catalog
    },
    {
        path: CATALOG_ROUTE + '/:subcategory',
        Component: Catalog
    },
    {
        path: PRODUCT_ROUTE + '/:id',
        Component: ProductCard
    },
    {
        path: BASKET_ROUTE,
        Component: Basket
    },
    {
        path: ABOUT_ROUTE,
        Component: About
    },
    {
        path: PAY_AND_SHIP_ROUTE,
        Component: PayAndShip
    },
    {
        path: WARRANTY_ROUTE,
        Component: Warranty
    },
    {
        path: REFUND_ROUTE,
        Component: Refund
    },
    {
        path: CONTACTS_ROUTE,
        Component: Contacts
    },
    {
        path: SERVICES_ROUTE,
        Component: Services
    },
    {
        path: BRANDS_ROUTE,
        Component: Brands
    },
    {
        path: POLICY_OPD_ROUTE,
        Component: PolicyOpd
    },    
    // {
    //     path: MAP_ROUTE,
    //     Component: Map
    // },


    // {
    //     path: REGISTRATION_ROUTE,
    //     Component: Auth
    // },
    
]